<template>
  <v-data-table
    :pagination.sync="pagination"
    :loading="loading"
    :headers="headers"
    :items="operators"
    class="elevation-1"
  >
    <template v-slot:items="props">
      <tr>
        <td>
          <v-btn
            :to="{name:'operator', params:{id: props.item.account_n}}"
          >{{ props.item.account_n }}</v-btn>
        </td>
        <td>
          <v-btn
            :to="{name:'operator', params:{id: props.item.related_n}}"
            v-if="props.item.related_n > 0"
          >{{ props.item.related_n }}</v-btn>
        </td>
        <td>{{ props.item.fee_earner }}</td>
        <td>{{ props.item.surname }}</td>
        <td>{{ props.item.branch_code }}</td>
        <td>{{ props.item.categor }}</td>
        <td>{{ props.item.subject }}</td>
        <td>
          <File :file="props.item.fileMini" v-if="props.item.fileMini" />
        </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import File from "@/components/link/File";
export default {
  name: "Operators",
  props: ["operators", "loading"],
  components: { File },
  data() {
    return {
      headers: [
        {
          text: "Reference",
          value: "account_n"
        },
        {
          text: "Related",
          value: "related_n"
        },
        {
          text: "Fee earner",
          value: "fee_earner"
        },
        {
          text: "Surname",
          value: "surname"
        },
        {
          text: "Branch",
          value: "branch_code"
        },
        {
          text: "Category",
          value: "categor"
        },
        {
          text: "Property",
          value: "subject"
        },
        {
          text: "Autolaw",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "account_n",
        descending: true
      }
    };
  }
};
</script>